import type { FaireProductEntity } from "../../entity_types/product";

export const p_r9q4kuun72: FaireProductEntity = {
  token: "p_r9q4kuun72",
  type: "product",
  name: "Tan Bandana Zip Sweater",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/eb7ae7550d2abee934f15b08e67a193dd3e0a714769adfa0c688d97202e372c1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9dfd41fd83b99e65e91828dd07629f5e894e586c6e2f5f60e500e681610511ba.jpeg",
    "https://cdn.faire.com/fastly/21db03c5327ee2697632d00f7748ded52b06e3194ac1785c527034d15ceb8485.jpeg",
    "https://cdn.faire.com/fastly/03695271f4d27d0ff04e7c54fa5b5ae95ff75cabbfe49dcc1bc43d8d1ff6ffcd.jpeg",
    "https://cdn.faire.com/fastly/bc403a6e2ad96d3c93d8b7ca9d002c5968946e5ffca3ac74cb461ee2a98ae115.jpeg"
  ],
  priceDollars: 33.95,
  description: "Tan Bandana Zip Sweater featuring an allover black bandana-inspired pattern, designed with a classic collar, front zip closure, two front pockets, long sleeves, and a relaxed fit in a soft knit fabric for casual everyday wear or layering.\n\n39% Acrylic, 31% Polyester, 30% Polyamide\n\nPre-pack 1-2-2-2-1 (XS-XL)\n\nMin. Qty: 8",
  tags: [],
  msrpDollars: 84.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:56.242Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
